//@flow

// Maps Scandit's CapturedId to app fields; update here if the SDK shape changes.

export type CapturedIdFields = {
  firstName: string,
  lastName: string,
  dateOfBirth: string,
  licenseNumber: string,
  auditNum: ?string,
};

const pad2 = value => String(value).padStart(2, '0');

// dateOfBirth is a DateResult ({ day, month, year }); returns MM/DD/YYYY.
const formatDateOfBirth = dateOfBirth => {
  if (!dateOfBirth) return '';
  const { day, month, year } = dateOfBirth;
  return `${pad2(month)}/${pad2(day)}/${year}`;
};

export const extractCapturedIdFields = (capturedId: Object): CapturedIdFields => ({
  firstName: capturedId.firstName || '',
  lastName: capturedId.lastName || '',
  dateOfBirth: formatDateOfBirth(capturedId.dateOfBirth),
  licenseNumber: capturedId.documentNumber || '',
  auditNum:
    (capturedId.barcode && capturedId.barcode.documentDiscriminatorNumber) ||
    null,
});
